import {PHASES, WAR_PHASE_STAGES} from "../../constants/phases";
import {
  selectGameResults,
  selectIsGameStarted,
  selectPhase,
  selectWarPhaseStage
} from "../../redux/reducers/sharedStateReducer/selectors";
import {
  selectIsTutorialActive,
  selectIsUnitAutoSelectionEnabled
} from "../../redux/reducers/privateStateReducer/selectors";
import {checkIfCurrentUserTurnInState} from "../gameState/user/checkIfCurrentUserTurnInState";

// Этапы, на которых у отрядов есть дела (spec phase-progress): на найме и в
// ближнем бою автовыбор не работает
export const UNIT_AUTO_SELECTION_STAGES = Object.freeze([
  WAR_PHASE_STAGES.MOVEMENT,
  WAR_PHASE_STAGES.ABILITIES,
  WAR_PHASE_STAGES.SHOOTING,
  WAR_PHASE_STAGES.MANEUVER,
]);

/**
 * Этап, на котором можно пропускать ход отрядом: свой ход на одном из этапов
 * автовыбора. Пропуск работает и при выключенном тумблере, но не в обучении:
 * глава ведет игрока по шагам, и пробел или незнакомая кнопка в футере
 * помечали бы отряды обработанными в обход сценария
 */
export const checkIfUnitTurnSkipStage = (state) => selectIsGameStarted(state)
  && !(selectGameResults(state)?.length > 0)
  && selectPhase(state) === PHASES.WAR
  && UNIT_AUTO_SELECTION_STAGES.includes(selectWarPhaseStage(state))
  && checkIfCurrentUserTurnInState(state)
  && !selectIsTutorialActive(state);

/**
 * Выбирает ли автовыбор отряды и двигает ли камеру прямо сейчас (spec
 * unit-auto-selection, «Этапы и режимы автовыбора»): свой ход на этапе
 * перемещения, способностей, стрельбы или манёвра, тумблер включен, не
 * обучение. Чужой ход, ход бота, зритель и запись матча отсекает
 * checkIfCurrentUserTurnInState; демо-партия меню автовыбор не подключает
 */
export const checkIfUnitAutoSelectionActive = (state) => checkIfUnitTurnSkipStage(state)
  && selectIsUnitAutoSelectionEnabled(state);
